"use client";

import { FormEvent, useState } from "react";
import Link from "next/link";

export default function HomePage() {
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState("");
  const [shareMessage, setShareMessage] = useState("");
  const [showPricing, setShowPricing] = useState(false);

  const prices = [
    ["Модератор", "15 рублей или 5 звезд"],
    ["Старший модератор", "20 рублей или 10 звезд"],
    ["Администратор", "25 рублей или 15 звезд"],
    ["Старший администратор", "30 рублей или 20 звезд"],
    ["ГС/ЗГС", "40 рублей или 25 звезд"],
    ["Куратор администрации", "45 рублей или 35 звезд"],
    ["Технический специалист", "50 рублей или 40 звезд"],
    ["Заместитель Главного администратора", "60 рублей или 45 звезд"],
    ["Главный администратор", "70 рублей или 50 звезд"],
    ["Команда проекта", "75 рублей или 60 звезд"],
    ["Заместитель основателя", "по доверенности"],
  ];

  const uploadGame = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setUploading(true);
    setMessage("");
    const response = await fetch("/api/game", {
      method: "POST",
      body: new FormData(event.currentTarget),
    });
    const result = (await response.json()) as { message?: string; error?: string };
    setMessage(result.message || result.error || "Что-то пошло не так.");
    setUploading(false);
  };

  const shareSite = async () => {
    const shareData = {
      title: "ICE RUSSIAN",
      text: "Скачай ICE RUSSIAN и окунись в холодную атмосферу.",
      url: window.location.href,
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData);
        setShareMessage("Ссылка готова к отправке");
      } else {
        await navigator.clipboard.writeText(shareData.url);
        setShareMessage("Ссылка скопирована");
      }
    } catch {
      setShareMessage("");
    }
  };

  return (
    <main className="relative min-h-dvh overflow-hidden px-5 py-6 sm:px-10 sm:py-8" data-amazi-id={"donate-icerussian/src/app/page.tsx:60:5"}>
      <div className="ice-glow ice-glow-one" data-amazi-id={"donate-icerussian/src/app/page.tsx:61:7"} />
      <div className="ice-glow ice-glow-two" data-amazi-id={"donate-icerussian/src/app/page.tsx:62:7"} />
      <nav className="relative mx-auto flex max-w-6xl items-center justify-between" data-amazi-id={"donate-icerussian/src/app/page.tsx:63:7"}>
        <Link href="/" className="flex items-center gap-3 font-bold tracking-tight" data-amazi-jsx-id={"donate-icerussian/src/app/page.tsx:64:9"}>
          <span className="grid h-10 w-10 place-items-center rounded-xl bg-[#bff4ff] text-lg text-[#07101e] shadow-[0_0_30px_rgba(161,239,255,.4)]" data-amazi-id={"donate-icerussian/src/app/page.tsx:65:11"}>
            ❄
          </span>
          <span data-amazi-id={"donate-icerussian/src/app/page.tsx:68:11"}>
            donate<span className="text-[#a5eaff]" data-amazi-id={"donate-icerussian/src/app/page.tsx:69:19"}>.icerussian</span>
          </span>
        </Link>
        <div className="flex items-center gap-4" data-amazi-id={"donate-icerussian/src/app/page.tsx:72:9"}>
          <button
            type="button"
            onClick={shareSite}
            className="share-button inline-flex items-center gap-2 rounded-full border border-white/15 px-4 py-2 text-sm font-bold text-slate-200 transition hover:border-[#a5eaff] hover:text-[#bff4ff]"
           data-amazi-id={"donate-icerussian/src/app/page.tsx:73:11"}>
            <span aria-hidden="true" data-amazi-id={"donate-icerussian/src/app/page.tsx:78:13"}>↗</span>
            Поделиться сайтом
          </button>
          <span className="hidden text-sm text-slate-400 sm:block" data-amazi-id={"donate-icerussian/src/app/page.tsx:81:11"}>ICE RUSSIAN / 2025</span>
        </div>
      </nav>
      <div className="relative mx-auto mt-6 max-w-6xl" data-amazi-id={"donate-icerussian/src/app/page.tsx:84:7"}>
        <button
          type="button"
          onClick={() => setShowPricing(true)}
          className="rounded-full border border-[#a5eaff]/40 px-4 py-2 text-left text-sm font-bold text-[#bff4ff] transition hover:border-[#bff4ff] hover:bg-[#bff4ff]/10"
         data-amazi-id={"donate-icerussian/src/app/page.tsx:85:9"}>
          Стоимость административных позиций
        </button>
      </div>
      {showPricing ? (
        <section className="relative mx-auto max-w-4xl pb-20 pt-20" aria-labelledby="pricing-title" data-amazi-id={"donate-icerussian/src/app/page.tsx:94:9"}>
          <button
            type="button"
            onClick={() => setShowPricing(false)}
            className="mb-10 rounded-full border border-white/15 px-5 py-3 text-sm font-bold text-slate-200 transition hover:border-[#a5eaff] hover:text-[#bff4ff]"
           data-amazi-id={"donate-icerussian/src/app/page.tsx:95:11"}>
            ← Вернуться обратно
          </button>
          <p className="text-sm font-bold uppercase tracking-[.24em] text-[#a5eaff]" data-amazi-id={"donate-icerussian/src/app/page.tsx:102:11"}>ICE RUSSIAN</p>
          <h1 id="pricing-title" className="mt-4 text-4xl font-black tracking-tight sm:text-6xl" data-amazi-id={"donate-icerussian/src/app/page.tsx:103:11"}>
            Цены на администрацию
          </h1>
          <p className="mt-5 max-w-xl text-lg leading-8 text-slate-400" data-amazi-id={"donate-icerussian/src/app/page.tsx:106:11"}>
            Стоимость административных позиций:
          </p>
          <div className="pricing-list mt-10 overflow-hidden rounded-3xl border border-white/10" data-amazi-id={"donate-icerussian/src/app/page.tsx:109:11"}>
            {prices.map(([role, price]) => (
              <div
                key={role}
                className="flex flex-col gap-2 border-b border-white/10 px-6 py-5 last:border-b-0 sm:flex-row sm:items-center sm:justify-between sm:px-8"
               data-amazi-id={"donate-icerussian/src/app/page.tsx:111:15"}>
                <span className="font-bold text-white" data-amazi-id={"donate-icerussian/src/app/page.tsx:115:17"}>{role}</span>
                <span className="text-[#a5eaff]" data-amazi-id={"donate-icerussian/src/app/page.tsx:116:17"}>{price}</span>
              </div>
            ))}
          </div>
        </section>
      ) : (
        <section className="relative mx-auto grid max-w-6xl items-center gap-14 pb-20 pt-20 lg:grid-cols-[1fr_.8fr] lg:pt-28" data-amazi-id={"donate-icerussian/src/app/page.tsx:122:9"}>
          <div data-amazi-id={"donate-icerussian/src/app/page.tsx:123:11"}>
            <p className="mb-6 flex items-center gap-2 text-sm font-bold uppercase tracking-[.24em] text-[#a5eaff]" data-amazi-id={"donate-icerussian/src/app/page.tsx:124:13"}>
              <span className="h-2 w-2 rounded-full bg-[#a5eaff] shadow-[0_0_12px_#a5eaff]" data-amazi-id={"donate-icerussian/src/app/page.tsx:125:15"} />{" "}
              официальный сайт
            </p>
            <h1 className="max-w-2xl text-5xl font-black leading-[.95] tracking-[-.05em] sm:text-7xl" data-amazi-id={"donate-icerussian/src/app/page.tsx:128:13"}>
              Привет.
              <br data-amazi-id={"donate-icerussian/src/app/page.tsx:130:15"} />
              <span className="ice-text" data-amazi-id={"donate-icerussian/src/app/page.tsx:131:15"}>
                Здесь ты сможешь
                <br data-amazi-id={"donate-icerussian/src/app/page.tsx:133:17"} />
                установить ICE RUSSIAN
              </span>
              <span className="ml-3 inline-block text-5xl sm:text-7xl" data-amazi-id={"donate-icerussian/src/app/page.tsx:136:15"}>🇷🇺</span>
            </h1>
            <p className="mt-8 max-w-lg text-lg leading-8 text-slate-400" data-amazi-id={"donate-icerussian/src/app/page.tsx:138:13"}>
              Скачай последнюю версию игры и окунись в холодную атмосферу. Всё необходимое — в одном
              месте.
            </p>
            <div className="mt-10 flex flex-wrap items-center gap-4" data-amazi-id={"donate-icerussian/src/app/page.tsx:142:13"}>
              <a
                href="/api/game"
                className="download-button inline-flex items-center gap-3 rounded-full px-7 py-4 font-bold transition"
               data-amazi-id={"donate-icerussian/src/app/page.tsx:143:15"}>
                <span className="text-xl" data-amazi-id={"donate-icerussian/src/app/page.tsx:147:17"}>↓</span>
                Установить игру
              </a>
              <span className="text-sm text-slate-500" data-amazi-id={"donate-icerussian/src/app/page.tsx:150:15"}>Скачать игру</span>
            </div>
            {shareMessage && <p className="mt-4 text-sm text-[#a5eaff]" data-amazi-id={"donate-icerussian/src/app/page.tsx:152:30"}>{shareMessage}</p>}
          </div>
          <div className="hero-card relative mx-auto w-full max-w-md rounded-[2rem] border border-white/10 p-5" data-amazi-id={"donate-icerussian/src/app/page.tsx:154:11"}>
            <div className="flex aspect-[4/5] flex-col justify-between overflow-hidden rounded-[1.4rem] bg-gradient-to-br from-[#163c57] via-[#0d2038] to-[#08101f] p-7" data-amazi-id={"donate-icerussian/src/app/page.tsx:155:13"}>
              <div className="flex justify-between text-xs font-bold uppercase tracking-[.2em] text-[#a5eaff]" data-amazi-id={"donate-icerussian/src/app/page.tsx:156:15"}>
                <span data-amazi-id={"donate-icerussian/src/app/page.tsx:157:17"}>ICE RUSSIAN</span>
                <span data-amazi-id={"donate-icerussian/src/app/page.tsx:158:17"}>01</span>
              </div>
              <div data-amazi-id={"donate-icerussian/src/app/page.tsx:160:15"}>
                <div className="ice-mark" data-amazi-id={"donate-icerussian/src/app/page.tsx:161:17"}>❄</div>
                <p className="mt-6 text-3xl font-black tracking-tight" data-amazi-id={"donate-icerussian/src/app/page.tsx:162:17"}>
                  Холодная
                  <br data-amazi-id={"donate-icerussian/src/app/page.tsx:164:19"} />
                  сторона игры.
                </p>
                <p className="mt-3 text-sm text-slate-400" data-amazi-id={"donate-icerussian/src/app/page.tsx:167:17"}>
                  Создано для тех, кто не боится мороза.
                </p>
              </div>
            </div>
          </div>
        </section>
      )}
      <section className="relative mx-auto max-w-6xl border-t border-white/10 py-10" data-amazi-id={"donate-icerussian/src/app/page.tsx:175:7"}>
        <div className="flex flex-col justify-between gap-8 sm:flex-row sm:items-end" data-amazi-id={"donate-icerussian/src/app/page.tsx:176:9"}>
          <div data-amazi-id={"donate-icerussian/src/app/page.tsx:177:11"}>
            <p className="text-xs font-bold uppercase tracking-[.2em] text-slate-500" data-amazi-id={"donate-icerussian/src/app/page.tsx:178:13"}>
              Для владельца сайта
            </p>
            <h2 className="mt-2 text-2xl font-bold" data-amazi-id={"donate-icerussian/src/app/page.tsx:181:13"}>Обновить ссылку на игру</h2>
          </div>
          <form
            onSubmit={uploadGame}
            className="flex w-full max-w-xl flex-col gap-3 sm:flex-row sm:items-end"
           data-amazi-id={"donate-icerussian/src/app/page.tsx:183:11"}>
            <label className="flex-1 text-sm text-slate-400" data-amazi-id={"donate-icerussian/src/app/page.tsx:187:13"}>
              Ссылка на игру в Google Drive
              <input
                required
                name="url"
                type="url"
                placeholder="https://drive.google.com/..."
                className="mt-2 block w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-white outline-none focus:border-[#a5eaff]" data-amazi-id={"donate-icerussian/src/app/page.tsx:189:15"}
              />
            </label>
            <label className="text-sm text-slate-400" data-amazi-id={"donate-icerussian/src/app/page.tsx:197:13"}>
              Пароль
              <input
                required
                name="password"
                type="password"
                placeholder="Пароль админа"
                className="mt-2 w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-white outline-none focus:border-[#a5eaff] sm:w-44" data-amazi-id={"donate-icerussian/src/app/page.tsx:199:15"}
              />
            </label>
            <button
              disabled={uploading}
              className="rounded-xl bg-white px-5 py-3 font-bold text-[#07101e] transition hover:bg-[#bff4ff] disabled:opacity-50"
             data-amazi-id={"donate-icerussian/src/app/page.tsx:207:13"}>
              {uploading ? "Сохранение…" : "Обновить"}
            </button>
          </form>
        </div>
        {message && <p className="mt-4 text-sm text-[#a5eaff]" data-amazi-id={"donate-icerussian/src/app/page.tsx:215:21"}>{message}</p>}
        <p className="mt-8 text-xs text-slate-600" data-amazi-id={"donate-icerussian/src/app/page.tsx:216:9"}>
          Сначала загрузите APK на Google Drive, откройте доступ по ссылке и вставьте её сюда.
        </p>
      </section>
    </main>
  );
}
